import { createSelector } from 'reselect';
import { getIconUrl, imageEntities } from '../../../utils/ImagesCreator';

const selectSchedulerState = (state) => state.schedulerReducer || {};

const EMPTY_APPOINTMENTS = {};
const EMPTY_WORKERS = [];
const EMPTY_SERVICES = [];

const selectAppointments = createSelector(
  selectSchedulerState,
  (state) => state.calendar?.appointments || EMPTY_APPOINTMENTS,
);
const selectWorkers = createSelector(
  selectSchedulerState,
  (state) => (Array.isArray(state.calendar?.workers) ? state.calendar.workers : EMPTY_WORKERS),
);
const selectServices = createSelector(
  selectSchedulerState,
  (state) => (Array.isArray(state.calendar?.services) ? state.calendar.services : EMPTY_SERVICES),
);

export const getCalendarLayoutSource = createSelector(
  [selectAppointments, selectWorkers, selectServices],
  (appointments, workers, services) => ({ appointments, workers, services }),
);

export const getCalendarWorkers = () =>
  createSelector(selectSchedulerState, (state) =>
    (Array.isArray(state.calendar?.workers) ? state.calendar.workers : []).map((worker) => ({
      name: worker.nome_referente,
      value: worker.idpoltrona,
      icon: getIconUrl(worker.idpoltrona, imageEntities.worker),
    })),
  );
export const getCalendarSlots = () =>
  createSelector(selectSchedulerState, (state) => state.availableSlots);
/** Stable selector — prefer this over getCalendarData() in components. */
export const selectCalendarData = createSelector(
  selectSchedulerState,
  (state) => state.calendar || null,
);
export const getCalendarData = () => selectCalendarData;
export const getCalendarLoading = () =>
  createSelector(selectSchedulerState, (state) => !!state.calendarLoading);
export const getCalendarLoaded = () =>
  createSelector(selectSchedulerState, (state) => !!state.calendarLoaded);
export const getCalendarWorker = (id) =>
  createSelector(selectSchedulerState, (state) =>
    (Array.isArray(state.calendar?.workers) ? state.calendar.workers : []).find(
      (worker) => +worker.idpoltrona === +id,
    ),
  );
export const getCalendarWorkerServices = () =>
  createSelector(selectSchedulerState, (state) =>
    (Array.isArray(state.calendar?.services) ? state.calendar.services : []).map((service) => ({
      // value: service.idServiziPoltrona,
      idServiziPoltrona: service.idServiziPoltrona,
      idServizio: service.idServizio,
      idPoltrona: service.idPoltrona,
      durata: service.durata,
      prezzo: service.prezzo,
      disabilitato: service.disabilitato,
      onlyVisible: service.onlyVisible,
      idservezio: service.idservezio,
      time: service.time,
      value: service.idServizio,
      name: service.nome,
      icon: getIconUrl(service.idServizio, imageEntities.service),
      worker_id: +service.idpoltrona,
      duration: service.durata,
    })),
  );

export const getTaskById = (id) =>
  createSelector(selectSchedulerState, (state) =>
    Object.entries(state.calendar?.appointments || {}).reduce((acc, [data, tasks]) => {
      const foundTask = (tasks || []).find((task) => +task.idprenotazione === +id);
      if (foundTask) {
        return foundTask;
      }
      return acc;
    }, {}),
  );

export const getCalendarQueue = () =>
  createSelector(selectSchedulerState, (state) => {
    const workers = (Array.isArray(state.calendar?.queue) ? state.calendar.queue : [])
      // .filter(worker => worker.listaAttesa?.length > 0)
      .map((worker) => ({
        id: worker.idpoltrona,
        name: worker.nome_referente,
        icon: getIconUrl(worker.idpoltrona, imageEntities.worker),
        clients: (worker.listaAttesa || []).map((client) => ({
          id: client.idUtente,
          queueId: client.idListaAttesa,
          name: `${client.nome} ${client.cognome}`,
          phone: client.cellulare,
          icon: '',
          duration: client.tempo,
        })),
      }));
    const clientsLength = workers.reduce((acc, item) => acc + item.clients.length, 0);
    return {
      workers,
      clientsLength,
      date: state.queueDate || null,
    };
  });
export const infoRiccorrenzaSelect = () =>
  createSelector(selectSchedulerState, (state) => state.detaglioPrenotazioneRicorrente);
